import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateMultiCustomerGroupOrder,
  CustomerGroupOrderApi,
  DeleteMultiCustomerGroupOrderBody,
} from 'api';

export const findCustomerGroupOrders = createAsyncThunk(
  'customerGroupOrder/findCustomerGroupOrders',
  async (_, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.findCustomerGroupOrders();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerGroupOrderWithEntity = createAsyncThunk(
  'customerGroupOrder/findCustomerGroupOrderWithEntity',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPartnerForCreateWithCustomerID = createAsyncThunk(
  'customerGroupOrder/findPartnerForCreateWithCustomerID',
  async (id: string, { rejectWithValue }) => {
    try {
      const response =
        await CustomerGroupOrderApi.findPartnerForCreateWithCustomerID(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPartnerForCreateCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/findPartnerForCreateCustomerGroupOrder',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.findPartnerForCreate(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/findOneCustomerGroupOrder',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await CustomerGroupOrderApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/updateCustomerGroupOrder',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CustomerGroupOrderApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/deleteCustomerGroupOrder',
  async (params: { id: string; option: any }, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await CustomerGroupOrderApi.delete(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteMultiCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/deleteMultiCustomerGroupOrder',
  async (body: DeleteMultiCustomerGroupOrderBody, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.deleteMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomerGroupOrderSort = createAsyncThunk(
  'customerGroupOrder/updateCustomerGroupOrderSort',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.sort(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiCustomerGroupOrder = createAsyncThunk(
  'customerGroupOrder/createMultiCustomerGroupOrder',
  async (body: CreateMultiCustomerGroupOrder, { rejectWithValue }) => {
    try {
      const response = await CustomerGroupOrderApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const customerGroupOrderSlice = createSlice({
  name: 'customerGroupOrder',
  initialState: {},
  reducers: {},
});

const { reducer: customerGroupUserReducer } = customerGroupOrderSlice;

export default customerGroupUserReducer;
